import { z } from 'zod';
/**
 * Helper for required string fields with custom error messages
 * Shows the same error message for undefined, null, and empty string cases
 *
 * Uses z.preprocess to transform undefined/null values to empty strings before validation,
 * ensuring consistent error messages regardless of whether the field is missing or empty
 *
 * @param message - The error message to show when field is missing or empty
 * @returns Zod string schema with required validation
 *
 * @example
 * const schema = z.object({
 *   name: requiredString('Name is required')
 * });
 */
export const requiredString = (message) => z.preprocess((val) => (val === undefined || val === null ? '' : val), z.string().min(1, message));
//# sourceMappingURL=helpers.js.map